export default "__VITE_ASSET__SZsV0OEg__"